<template>
  <div class="bot-actions">
      <v-icon @click="openActions = !openActions">
        mdi-dots-horizontal
      </v-icon>
    <div>
      <div class="bot-actions-wrapper" :class="openActions? 'activeActions': ''">
        <v-btn
          fab
          dark
          small
          color="primary"
          flat
          class="nd1 nds"
          @click="duplicateDialog = true">
          <v-icon light >file_copy</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          class="nd2 nds"
          small
          flat
          color="error"
          @click="deleteBlockDialog = true"
        >
          <v-icon light>delete_outline</v-icon>
        </v-btn>
      </div>
    </div>

    <v-dialog
      v-model="deleteBlockDialog"
      width="500"
    >
      <delete-dialog
        :title="bot.title"
        :delete-check-value="bot.title"
        @closeDialog="deleteBlockDialog = false"
        @onDelete="deleteBlock"
      />
    </v-dialog>
    <v-dialog v-model="duplicateDialog" width="500">
      <v-card>
        <v-card-title
          class="headline"
          primary-title>
          Duplicate  {{bot.title}}
        </v-card-title>
        <v-card-text>
          <v-text-field
            outline
            v-model="cloneObj.bot_name"
            placeholder="New Name"
            type="text"
            flat
          ></v-text-field>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="!cloneObj.bot_name.trim().length"
            :loading = "addButtonLoader"
            color="primary"
            @click="duplicate">
            Duplicate
          </v-btn>
          <v-btn
            outline
            @click="duplicateDialog = false">
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import deleteDialog from "../common/deleteDialog";
  import common from "../../utils/common";
  export default {
    name: "botActions",
    components: {
      deleteDialog
    },
    props: {
      bot: {
        type: Object,
        default: ()=>{
          return {}
        }
      }
    },
    data () {
      return {
        deleteBlockDialog: false,
        duplicateDialog: false,
        addButtonLoader: false,
        openActions: false,
        cloneObj: {
          bot_name: ''
        }
      }
    },
    methods: {
      duplicate() {
        this.addButtonLoader = true
        this.$http.post(`bot/${this.bot.id}/duplicate`,this.cloneObj)
          .then(response=>{
            this.deleteBlockDialog = false
            this.$emit('reloadBots')
            this.duplicateDialog = false
            setTimeout(()=>{
              window.scrollTo(0,document.body.scrollHeight)
            },2000)
          })
          .catch(error=>{
            this.addButtonLoader = false
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', true)
            }
          })
      },
      deleteBlock() {
        this.$http.delete(`bot/${this.bot.id}`)
        .then(response=>{
          this.deleteBlockDialog = false
          this.$emit('reloadBots')
          setTimeout(()=>{
            window.scrollTo(0,document.body.scrollHeight)
          },2000)
        })
        .catch(error=>{
          this.addButtonLoader = false
          if (error.response && error.response.status === 401) {
            common.logOut()
          } else {
            this.$store.dispatch('setErrorMessage', true)
          }
        })
      }
    }
  }
</script>

<style  lang="scss">
  .bot-actions {
    position: absolute;
    top: 5px;
    right: 10px;
    .v-btn--floating.v-btn--small {
      width: 20px;
      z-index: 10;
      height: 20px;
    }
  }

  .bot-actions-wrapper {
    position: absolute;
    right: -5px;
  }

  .nds{
    transform:  scale(0);
  }


  .nd1{
    animation-delay: 0.2s;
    animation: bounce-out-nds 0.3s linear;
    animation-fill-mode:  forwards;
  }
  .nd2{
    animation-delay: 0.15s;
    animation: bounce-out-nds 0.15s linear;
    animation-fill-mode:  forwards;
  }

  @keyframes bounce-nds{
    from {opacity: 0;}
    to {opacity: 1; transform: scale(1);}
  }

  @keyframes bounce-out-nds{
    from {opacity: 1; transform: scale(1);}
    to {opacity: 0; transform: scale(0);}
  }

  .activeActions .nds{

    animation: bounce-nds 0.1s linear;
    animation-fill-mode:  forwards;
  }

  .activeActions .nd1{
    animation-delay: 0.15s;
  }
  .activeActions .nd2{
    animation-delay: 0.08s;
  }
  .activeActions .nd3{
    animation-delay: 0.2s;
  }


  .activeActions .plug-trigger {
    transform: rotate(315deg);
  }
</style>
